import Login from './Login.vue';
import store from '@/store';
import authentication from '@/authentication';
import user from '@/components/user';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      isPublic: true,
    },
    async beforeEnter(to, from, next) {
      await store.dispatch(`${authentication.store.namespace}/checkLoggedIn`);
      const currentUser = store.state[user.store.namespace].currentUser;
      if ('approved' in currentUser && currentUser.approved) {
        if (to.query.redirect) {
          next({ path: to.query.redirect });
        } else {
          next({ name: 'Home' });
        }
      } else if (store.state[authentication.store.namespace].isLoggedIn) {
        next({ name: 'Settings' });
      } else {
        next();
      }
    },
  },
  {
    path: '/login/:dealerNumber/:userId',
    name: 'LoginParams',
    component: Login,
    meta: {
      isPublic: true,
    },
    async beforeEnter(to, from, next) {
      if (store['vue-persist-patch-delay']) {
        await store['vue-persist-patch-delay'];
      }
      const actions = [];
      if (to.params.dealerNumber) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setDealerNumber`,
            to.params.dealerNumber
          )
        );
      }
      if (to.params.userId) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setUserId`,
            to.params.userId
          )
        );
      }

      Promise.all(actions).then(next).catch(next);
    },
  },
];

export default routes;
